module.exports = __webpack_public_path__ + "img/72.10.pH.5e9ecb12.png";